import css from "./Header.module.css";
import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

const Hamburger = () => {
  const [showNav, setShowNav] = useState(false);
  const containerRef = useRef(null);

  const toggleNav = () => {
    setShowNav((old) => !old);
  };

  useEffect(() => {
    if (!showNav) return;

    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowNav(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showNav]);

  return (
    <div
      className={css.hamburger_container}
      onClick={toggleNav}
      ref={containerRef}
    >
      <div className={css.hamburger}>
        <div className={css.hamburger_line} />
        <div className={css.hamburger_line} />
        <div className={css.hamburger_line} />
      </div>
      {showNav && (
        <nav className={`${css.hamburger_links} background_white shadow`}>
          <a
            className={`${css.cta} ${css.portal}`}
            href="https://crystalclearconsulting.smartvault.com/secure/SignIn.aspx"
            target="_blank"
            rel="noopener noreferrer"
          >
            Client Portal
          </a>
          <Link
            className={css.hamburger_link}
            onClick={toggleNav}
            to="/bookkeeping"
          >
            Bookkeeping
          </Link>
          <Link
            className={css.hamburger_link}
            onClick={toggleNav}
            to="/consulting"
          >
            Consulting
          </Link>
          <Link
            className={css.hamburger_link}
            onClick={toggleNav}
            to="/payroll"
          >
            Payroll
          </Link>
          <Link
            className={css.hamburger_link}
            onClick={toggleNav}
            to="/registration"
          >
            Registration
          </Link>
        </nav>
      )}
    </div>
  );
};

export default Hamburger;
